import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, Platform, Events, ToastController, AlertController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import * as $ from 'jquery';

declare var $;

@IonicPage()
@Component({
  selector: 'page-detail-card',
  templateUrl: 'detail.html'
})

export class Detail {
  selectedItem: any;
  title: any;
  contentTitle: string = "";
  noticePlaceholder: string = "";
  getDetailDataUrl: string = "";
  refreshDetailDataUrl: string = "";
  cornerColor: string = "";
  pageDetailData: any;
  pageDetailDataProcessed: any;
  _ebsComponentService: any;
  showQRCODE: boolean = true;
  showPrevBtn: boolean = false;
  showNextBtn: boolean = false;
  showDetailMenuBtn: boolean = false;

  checkCancelDynamic: boolean = false;
  showAltCancelBtn: boolean = false;
  altCancelValue: any;

  checkFinishDynamic: boolean = false;
  showAltFinishBtn: boolean = false;
  altFinishValue: any;

  showCalculatedNettoPreis: boolean = false;

  positionTotalSum: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public _ebsWebService: EbsWebService,
    public _ebsWebServiceGlobals: EbsWebServiceGlobals,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    public platform: Platform,
    public events: Events,
    //private cdRef: ChangeDetectorRef,
    private toastCtrl: ToastController) {

    this._ebsComponentService = new EbsComponentService(_ebsWebService, _ebsWebServiceGlobals);

    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      this.showQRCODE = false;
    }

    this.title = navParams.get('caption');
    this.selectedItem = navParams.get('item');
    this.getDetailDataUrl = navParams.get('actionURL');

    this.loadDetailPageData(this.getDetailDataUrl);

    this.events.subscribe('detail:reloadPageWithResponse', (res) => {
      this.loadDetailPageWithResponse(res);
    });

    events.publish("reloadMenu");
  }

  ionViewWillEnter() {
    if (this.refreshDetailDataUrl != "") {
      let urlParts = this.refreshDetailDataUrl.split("?");
      this.loadDetailPageData(urlParts[0], urlParts[1]);
    }
  }

  loadDetailPageData(url, params = null) {
    if (typeof url != "undefined") {
      let loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
      });
      loading.present();
      let postParams = this.navParams.get('postParams');
      if (params != null && params != "") {
        postParams = params;
      }
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(postParams);
      this.pageDetailData = this._ebsWebService.postData(url, postPayloadObject).subscribe((res) => {
        this.loadDetailPageWithResponse(res);
        loading.dismiss();
      });
    }
  }

  loadDetailPageWithResponse(res) {
    if (res.Dynamic != null && typeof res.Dynamic.CustomMainTitle != "undefined" && res.Dynamic.CustomMainTitle != null) {
      this.title = res.Dynamic.CustomMainTitle;
    } else {
      this.title = res.MainTitle;
    }

    if (res.Dynamic != null) {
      if (typeof res.Dynamic.CornerColor != "undefined" && res.Dynamic.CornerColor != null) {
        this.cornerColor = res.Dynamic.CornerColor;
      }

      if (typeof res.Dynamic.ContentTitle != "undefined" && res.Dynamic.ContentTitle != null) {
        this.contentTitle = res.Dynamic.ContentTitle;
      }

      if (typeof res.Dynamic.CommentBoxText != "undefined" && res.Dynamic.CommentBoxText != null) {
        this.noticePlaceholder = res.Dynamic.CommentBoxText;
      }

      if (typeof res.Dynamic.CalculateDynamicNettoPreis != "undefined" && res.Dynamic.CalculateDynamicNettoPreis != null) {
        this.showCalculatedNettoPreis = true;
      }

      if (res.Dynamic.DetailMenuBtn == "True" && res.Dynamic.DetailMenuBtn != null) {
        this.showDetailMenuBtn = true;
      }

      if (res.Dynamic.PrevBtn == "True" && res.Dynamic.PrevBtn != null) {
        this.showPrevBtn = true;
      }

      if (res.Dynamic.NextBtn == "True" && res.Dynamic.NextBtn != null) {
        this.showNextBtn = true;
      }

      if (res.Dynamic.AltCancelBtn == "True" && res.Dynamic.AltCancelBtn != null) {
        this.checkCancelDynamic = true;
      }

      if (res.Dynamic.AltFinishBtn == "True" && res.Dynamic.AltFinishBtn != null) {
        this.checkFinishDynamic = true;
      }
    }

    this.checkIfCancel(res.ListItemContent);
    this.checkIfFinish(res.ListItemContent);


    this.pageDetailDataProcessed = this._ebsWebService.prepareWebServiceDataForView(res);

    console.log("this.pageDetailDataProcessed", this.pageDetailDataProcessed);

    //this.cdRef.detectChanges();
    if (typeof res.RefreshUrl != "undefined" && res.RefreshUrl != null && res.RefreshUrl != "") {
      this.refreshDetailDataUrl = res.RefreshUrl;
    }
    this._ebsWebService.setBrowserTabTitle(res.MainTitle);

    let counter = 0;
    if (this.pageDetailDataProcessed) {
      this.pageDetailDataProcessed.body.forEach(item => {
        item.left.forEach(element => {
          counter++;
          if (item.DataType == "System.GroupVertical" && item.DisplayTextStyle != null && item.DisplayTextStyle != "") {
            let currentCounter = counter - 1;
            let currentClass = ".quickInfoRow_" + currentCounter;

            this.calculateTotalSum(item.ListItemContent);

            $(currentClass).find(".quickInfoBtn").attr("style", item.DisplayTextStyle);
          }
        });
      });
    }
  }

  openPage(item) {
    var title;
    var actionURL;
    var postParams;
    if ((typeof item.Action != "undefined" && item.Action != "" && item.Action != null) ||
      (typeof item.ActionUrl != "undefined" && item.ActionUrl != "" && item.ActionUrl != null && item.ActionName == "HeaderItemClick")) {
      if (item.Dynamic != null && typeof item.Dynamic.NotClickable != "undefined" && item.Dynamic.NotClickable == "True" && item.Dynamic.NotClickable != "") {
        return;
      } else {
        if (item.ActionName != null && item.ActionName == "HeaderItemClick") {
          title = item.DisplayName;
          actionURL = item.ActionUrl;
          postParams = item.PostParameters;
        } else {
          title = item.MainTitle;
          actionURL = item.Action;
          postParams = item.PostParameters;
        }
        let navParams = {
          title: title,
          actionURL: actionURL,
          postParams: postParams
        };
        this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
      }
    } else {
      return;
    }
  }

  checkIfCancel(items) {
    if (this.checkCancelDynamic) {
      let count = 0;
      items.forEach(item => {
        count++;
        if (item.PostParameters != null) {
          if (item.PostParameters.includes("param1=CANCEL") || item.PostParameters.includes("param1=DELETE")) {
            this.altCancelValue = item;
            items.splice(count - 1, 1);
            this.showAltCancelBtn = true;
          }
        }
      });
    }
  }

  checkIfFinish(items) {
    if (this.checkFinishDynamic) {
      let count = 0;
      items.forEach(item => {
        count++;
        if (item.PostParameters != null) {
          if (item.PostParameters.includes("param1=FINISH")) {
            this.altFinishValue = item;
            items.splice(count - 1, 1);
            this.showAltFinishBtn = true;
          }
        }
      });
    }
  }


  deletePosition(element, event) {
    event.stopPropagation();
    let alert = this.alertCtrl.create({
      title: 'Wollen sie die Position löschen?',
      message: element.Dynamic.Title,
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Alert got canceled');
          }
        },
        {
          text: 'Bestätigen',
          handler: () => {
            console.log('Confirmed');
            this.deletePositionAction(element);
          }
        }
      ]
    });
    alert.present();

  }

  deletePositionAction(element) {
    if (typeof element.Action == "undefined" || element.Action == null) {
      return;
    }
    let params = element.PostParameters;

    if (params.match(/&path=*&/)) {
      params = params.replace(/&path=*&/, '&path=Delete&');
    } else {
      params = params + '&path=Delete';
    }

    if (params.match(/&action=.*&/)) {
      params = params.replace(/&action=.*&/, '&action=&');
    } else {
      params = params + '&action=';
    }

    if (params.match(/&district=.*&/)) {
      params = params.replace(/&district=.*&/, '&district=StrStrukturSchemaArtikel&');
    } else {
      params = params + '&district=StrStrukturSchemaArtikel';
    }

    if (!params.match(/&id=.*&/)) {
      params = params + '&id=' + element.ID;
    }

    params = params + '&editValue=';
    params = params + '&fieldName=';
    params = params + '&param1=';
    params = params + '&param2=';
    params = params + '&param3=';
    params = params + '&param4=';
    params = params + '&param5=';

    element.Action = element.Action.replace('GetAsJSON', 'SetValueAsJSON')
    element.AllowUpdate = true;


    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);



    this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(result => {
      if (result != null && typeof result != "undefined") {
        let toast = this.toastCtrl.create({
          message: "Position wurde erfolgreich gelöscht!",
          duration: 3000,
          position: 'bottom'
        });

        $("#quick-row-" + element.ID).hide("slow");

        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: "Fehler beim löschen der Position.",
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    });
  }


  changeValue(element, value, event) {
    event.stopPropagation();
    let addedValue: number = + element.Dynamic.Amount + +value;
    element.Dynamic.Amount = addedValue;

    this.positionTotalSum = Number((this.positionTotalSum + (element.Dynamic.VKP * value)).toFixed(2));

    this.updateValue(addedValue, element);
  }

  updateValue(value, element) {

    if (typeof element.Action == "undefined" || element.Action == null) {
      return;
    }
    let params = element.PostParameters;

    if (params.match(/&path=*&/)) {
      params = params.replace(/&path=*&/, '&path=Update&');
    } else {
      params = params + '&path=Update';
    }

    if (params.match(/&action=.*&/)) {
      params = params.replace(/&action=.*&/, '&action=&');
    } else {
      params = params + '&action=';
    }

    if (params.match(/&district=.*&/)) {
      params = params.replace(/&district=.*&/, '&district=StrStrukturSchemaArtikel&');
    } else {
      params = params + '&district=StrStrukturSchemaArtikel';
    }

    if (!params.match(/&id=.*&/)) {
      params = params + '&id=' + element.ID;
    }

    params = params + '&fieldName=v_MengeSar&editValue=' + value;

    params = params + '&param1=';
    params = params + '&param2=';
    params = params + '&param3=';
    params = params + '&param4=';
    params = params + '&param5=';

    element.Action = element.Action.replace('GetAsJSON', 'SetValueAsJSON')

    element.AllowUpdate = true;

    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);

    this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(result => {
      if (result != null && typeof result != "undefined") {
        let toast = this.toastCtrl.create({
          message: "Daten wurden erfolgreich gespeichert!",
          duration: 3000,
          position: 'bottom'
        });

        // To update the value 
        element.Dynamic.Value = (element.Dynamic.VKP * value).toFixed(2);



        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: "Fehler beim Speichern der Daten.",
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    });
  }


  calculateTotalSum(res) {
    for (var i = 0; i < res.length; i++) {
      try {
        let VKP: number = Number(res[i].Dynamic.VKP * res[i].Dynamic.Amount);
        this.positionTotalSum = Number((this.positionTotalSum + VKP).toFixed(2));
      } catch (error) {

      }

    }

  }




}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts